/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API75294Req {
  
  /** 文件地址 */
  fileUrl?: string;
};



export interface API75294Res {
  /**   */
  taskId?: string;
  
};


// 接口函数 75294 上传语音文件

export interface IUsePostAPI75294Return {
  /** 上传语音文件: 接口请求状态 */
  isAPI75294Loading: boolean;
  /** 上传语音文件: 接口请求返回数据 */
  dataAPI75294: API75294Res;
  /**  上传语音文件: 接口数据请求方法 */
  fetchAPI75294Data: (inputs: API75294Req, config?: YWRequestConfig) => Promise<API75294Res>;
  /** 上传语音文件: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75294 = ():IUsePostAPI75294Return => {
  let isMount = true;
  const [isAPI75294Loading, setIsAPI75294Loading] = useState(false);
  const [dataAPI75294, setDataAPI75294] = useState<API75294Res>({} as API75294Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/meeting/uploadVoiceFile`;

  const fetchAPI75294Data = async (inputs: API75294Req, config?: YWRequestConfig): Promise<API75294Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75294Req>) || {}) as API75294Req;
    
  
    if ( isMount ) {
      setIsAPI75294Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75294Res>(`${basePath}/yoaichat-web/chat/meeting/uploadVoiceFile`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75294(res || {} as API75294Res);
        setIsAPI75294Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75294Loading(false);
      }
      return false as unknown as API75294Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75294Loading,
    dataAPI75294,
    fetchAPI75294Data,
    requestUrl,
  }
}

